import MenuIcon from '@mui/icons-material/Menu';
import { useEffect, useRef, useState } from 'react';
import { MenuElement } from './MenuElement';
import { NavLink, useNavigate } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useAppDispatch, useAppSelector } from "../../store/hooks"
import { logUserOut } from '../../store/features/authSlice';
import { DividerLine } from '../common/DividerLine';
import { PrimaryButton } from '../buttons/PrimaryButton';
import PersonIcon from '@mui/icons-material/Person';
import { UserRole } from '../../dto/auth/User';

export const MainMenuButton = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const dispatch = useAppDispatch();

    const user = useAppSelector(state => state.auth.user);
    const navigate = useNavigate();

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setMenuOpen(false);
            }
        };

        const handleBlurOutside = () => {
            setMenuOpen(false);
        };

        document.addEventListener('mousedown', handleClickOutside);
        window.addEventListener('blur', handleBlurOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            window.removeEventListener('blur', handleBlurOutside);
        };
    }, []);

    const handleLogout = () => {
        dispatch(logUserOut());
    }

    const handleMenuOpen = (open: boolean) => {
        setMenuOpen(open);
    }

    return (
        <div ref={dropdownRef} className='min-w-[100px] h-full flex flex-col justify-center'>
            <div onMouseEnter={() => { menuOpen ? setMenuOpen(true) : setMenuOpen(true) }} onMouseLeave={(e) => {
                if ((e.relatedTarget as any).id === "application_top_bar" || (e.relatedTarget as any).id === "navbar_menu_right_elements") {
                    handleMenuOpen(false);
                }
            }} className="flex flex-row gap-1 cursor-pointer items-center text-sm font-semibold h-full">
                Minu Rentic
                <ExpandMoreIcon style={{ marginTop: "2px", width: "18px" }} />
            </div>
            {menuOpen &&
                <div onMouseLeave={() => handleMenuOpen(!menuOpen)} className='absolute top-[53px] -translate-x-5 flex bg-white flex-col text-start justify-start shadow-lg z-10 rounded-xl p-2'>
                    <NavLink
                        to="/"
                        className={({ isActive, isPending }) =>
                            isPending ? "pending" : isActive ? "bg-slate-100 rounded-xl" : ""
                        }
                        onClick={() => handleMenuOpen(false)}>
                        <MenuElement>
                            Otsing
                        </MenuElement>
                    </NavLink>
                    {user?.id ?
                        <div>
                            <NavLink
                                to="/my-orders"
                                className={({ isActive, isPending }) =>
                                    isPending ? "pending" : isActive ? "bg-slate-100 rounded-xl" : ""
                                }
                                onClick={() => handleMenuOpen(false)}>
                                <MenuElement>
                                    Minu laenutatud
                                </MenuElement>
                            </NavLink>
                            <NavLink
                                to="/rentals-chats"
                                className={({ isActive, isPending }) =>
                                    isPending ? "pending" : isActive ? "bg-slate-100 rounded-xl" : ""
                                }
                                onClick={() => handleMenuOpen(false)}>
                                <MenuElement subItem={true}>
                                    Vestlused
                                </MenuElement>
                            </NavLink>
                            <div className="w-full bg-primary h-[1px] opacity-50 my-2"></div>
                            <NavLink
                                to="/my-adverts"
                                className={({ isActive, isPending }) =>
                                    isPending ? "pending" : isActive ? "bg-slate-100 rounded-xl" : ""
                                }
                                onClick={() => handleMenuOpen(false)}
                            >
                                <MenuElement>
                                    Kõik kuulutused
                                </MenuElement>
                            </NavLink>
                            <NavLink
                                to="/my_rentals_status"
                                className={({ isActive, isPending }) =>
                                    isPending ? "pending" : isActive ? "bg-slate-100 rounded-xl" : ""
                                }
                                onClick={() => handleMenuOpen(false)}
                            >
                                <MenuElement>
                                    Aktiivsed rendid
                                </MenuElement>
                            </NavLink>
                            <NavLink
                                to="/chats"
                                className={({ isActive, isPending }) =>
                                    isPending ? "pending" : isActive ? "bg-slate-100 rounded-xl" : ""
                                }
                                onClick={() => handleMenuOpen(false)}>
                                <MenuElement subItem={true}>
                                    Vestlused
                                </MenuElement>
                            </NavLink>
                            <div className="w-full bg-primary h-[1px] opacity-50 my-2"></div>
                            {/* <NavLink
                                to="/favorites"
                                className={({ isActive, isPending }) =>
                                    isPending ? "pending" : isActive ? "bg-slate-100 rounded-xl" : ""
                                }
                                onClick={() => handleMenuOpen(false)}
                            >
                                <MenuElement>
                                    Meeldivaks märgitud
                                </MenuElement>
                            </NavLink> */}
                            <NavLink
                                to="/profile_edit"
                                className={({ isActive, isPending }) =>
                                    isPending ? "pending" : isActive ? "bg-slate-100 rounded-xl" : ""
                                }
                                onClick={() => handleMenuOpen(false)}
                            >
                                <MenuElement>
                                    <div className='flex flex-row'>
                                        <div className='w-[23px]'>
                                            <PersonIcon style={{width: "18px"}}></PersonIcon>
                                        </div>
                                        Profiil
                                    </div>

                                </MenuElement>
                            </NavLink>
                            {
                                user.role === UserRole.ADMIN &&
                                <NavLink
                                    to="/admin"
                                    className={({ isActive, isPending }) =>
                                        isPending ? "pending" : isActive ? "bg-slate-100 rounded-xl" : ""
                                    }
                                    onClick={() => handleMenuOpen(false)}
                                >
                                    <MenuElement>
                                        <div className='flex flex-row'>
                                            {/* <div className='w-[23px]'>
                                                <PersonIcon style={{width: "18px"}}></PersonIcon>
                                            </div> */}
                                            Adminleht
                                        </div>

                                    </MenuElement>
                                </NavLink>
                            }
                            <div className={`${!user ? "hidden" : ""} text-red-800 cursor-pointer`} onClick={handleLogout}>
                                <MenuElement>
                                    <div>
                                        Logi Välja
                                    </div>
                                </MenuElement>
                            </div>
                        </div>
                        :
                        <div className='mt-2'>
                            <PrimaryButton textSize='s' title='Logi sisse' onClick={() => { navigate("/login") }} />

                        </div>
                    }


                    <div></div>
                </div>
            }
        </div>
    )
}